// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d5568f83","453":"239417a3","796":"24409e37"}[chunkId] + ".chunk.js";
};